import { useForm } from "react-hook-form";
import AppBar from "../../../components/atoms/appbar";
import Button from "../../../components/atoms/button";
import Input from "../../../components/atoms/input";
import { useMutation } from "@tanstack/react-query";
import { emailUpdate, getMyInfo } from "../../../@apis/v1/auth.service";
import { getQueryClient } from "../../../@apis/queryClient";
import { useNavigate } from "react-router-dom";
import { useMyInfoStore } from "../../../lib/store/useMyInfoStore";
import { useModalStore } from "../../../lib/store/useModalStore";
import type { OnErrorResponse } from "../../../@apis/dto/response/common.response";

export default function SettingInfoEmail() {
  const { myInfo, setMyInfo } = useMyInfoStore();
  const { openModal } = useModalStore();
  const { register, handleSubmit, watch } = useForm<{ email: string }>({
    defaultValues: {
      email: myInfo.email,
    },
  });
  const navigate = useNavigate();

  const onSubmit = (form: { email: string }) => {
    updateEmailMutation.mutate(form.email);
  };

  const updateEmailMutation = useMutation({
    mutationFn: (email: string) => emailUpdate(email),
    onSuccess: async (res) => {
      const { success, error } = res;
      if (success) {
        const me = await getQueryClient().fetchQuery({
          queryKey: ["auth-my-info"],
          queryFn: getMyInfo,
        });
        setMyInfo(me.data);
        navigate(-1);
      } else {
        openModal("ALERT_DIALOG", {
          title: "에러",
          content:
            error?.code === "C003" ? "요청에 실패하였습니다." : error?.message,
        });
      }
    },
    onError: (err: OnErrorResponse) => {
      const { error } = err.response.data;
      openModal("ALERT_DIALOG", {
        title: "에러",
        content:
          error?.code === "C003" ? "요청에 실패하였습니다." : error?.message,
      });
    },
  });

  const disabledButton = () => {
    const email = watch("email") || "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return !emailRegex.test(email);
  };

  return (
    <div className="flex flex-col">
      <AppBar title="이메일 수정" backButton />
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="px-[16px] pb-[16px] flex flex-col justify-between min-h-[calc(100vh-56px)]">
          <div className="space-y-[25px]">
            <div className="space-y-[20px]">
              <p className="font-bold">이메일</p>
              <Input
                className="text-[0.7rem] placeholder:text-[0.7rem]"
                placeholder="이메일을 입력해주세요."
                {...register("email")}
              />
            </div>
          </div>

          <Button
            disabled={disabledButton()}
            type="submit"
            className="w-full"
            variant={disabledButton() ? "disabled" : "black"}
            label="수정 완료"
          />
        </section>
      </form>
    </div>
  );
}
